import block_icons from '../icons/advance_columns';
import color_palette_list from '../gb-helper/color_palette';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    MediaUpload, MediaUploadCheck, InnerBlocks } = wp.blockEditor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, Dashicon, RangeControl, TabPanel, ColorIndicator,
    ColorPalette, Button, Card, CardBody, __experimentalGradientPicker } = wp.components;

registerBlockType('blocksbakery/advanced-columns', {
    title: __('Advanced Columns', 'blocks-bakery'),
    description: __(
        'The advanced column block allows to insert many number of columns in a single row. This is an advanced option with customization ease to manage the look of this block on the page with different advanced shape dividers and many more.',
        'blocks-bakery'
    ),
    // common, formatting, layout, widgets, embed
    category: 'blocks_bakery',
    icon: block_icons.advace_icon,
    keywords: [
        __('advaced', 'blocks-bakery'),
        __('columns', 'blocks-bakery')
    ],

    supports: {
        html: false
    },
    attributes: {
        // border
        select_border: {
            type: 'string',
            default: 'dotted'
        },
        border_radius: {
            type: 'number',
            default:1,
        },
        border_width: {
            type: 'number',
            default: 1,
        },
        border_color: {
            type: 'string',
        },
        shadow_color: {
            type: 'string',
        },
        hori_shadow: {
            type: 'number',
            default: 0
        },
        vertical_shadow: {
            type: 'number',
            default: 0
        },
        blur_shadow: {
            type: 'number',
            default: 0
        },
        spread_shadow: {
            type: 'number',
            default: 0
        },
        shadow_selector: {
            type: 'text',
            default: ''
        },
        opacity_value: {
            type: 'string',
            default: 'FF'
        },
        // shape dividers
        select_divider_top: {
            type: 'string',
            default: 'none'
        },
        select_divider_bottom: {
            type: 'string',
            default: 'none'
        },
        divider_color_top: {
            type: 'string'
        },
        divider_opacity_top: {
            type: 'number',
            default: 1
        },
        divider_width_top: {
            type: 'number',
            default: 100
        },
        divider_height_top: {
            type: 'number',
        },
        divider_color_bottom: {
            type: 'string'
        },
        divider_opacity_bottom: {
            type: 'number',
            default: 1
        },
        divider_width_bottom: {
            type: 'number',
            default: 100
        },
        divider_height_bottom: {
            type: 'number',
        },
        select_type_bk_ft: {
            type: 'string',
            default: '-1'
        },
        shape_divider_position: {
            type: 'string',
            default: 'top'
        },
        // Background Setting
        background_setting: {
            type: 'string',
            source: 'text',
            default: 'None'
        },
        bg_color_opacity: {
            type: 'number',
            default: 1,
        },
        bg_color: {
            type: 'string',
        },
        gradient_selector: {
            type: "string",
            default: "linear-gradient"
        },
        color1: {
            type: 'string',
        },
        color2: {
            type: 'string',
        },
        location1: {
            type: "number",
            default: 40
        },
        location2: {
            type: "number",
            default: 70
        },
        angle: {
            type: "number",
            default: 180
        },
        img_ID: {
            type: 'number'
        },
        img_URL: {
            type: 'string',
            default: undefined
        },
        img_alt: {
            type: 'string',
            source: 'attribute',
            attribute: 'alt',
            selector: 'img'
        },
        imgbgposition: {
            type: "string",
        },
        bgimgattachment: {
            type: "string",
        },
        bgimgrepeat: {
            type: "string",
        },
        bgimgsize: {
            type: "string",
        },
        // Spacing
        top_padding: {
            type: 'number',
            default: 20,
        },
        bottom_padding: {
            type: 'number',
            default: 20,
        },
        left_padding: {
            type: 'number',
            default: 20,
        },
        right_padding: {
            type: 'number',
            default: 20,
        },
        top_margin: {
            type: 'number',
            default: 70
        },
        bottom_margin: {
            type: 'number',
            default: 70
        },
        left_margin: {
            type: 'number',
            default: 0
        },
        right_margin: {
            type: 'number',
            default: 0
        },
        // layout
        width_content: {
            type: 'number',
        },
        heading_tag: {
            type: 'string',
            default: 'section'
        },
        save_background: {
            type: 'string',
            default: "linear-gradient"
        },
        bg_selctor_type_img: {
            type: "string"
        },
        text_alignment: {
            type: 'string'
        },
        block_alignment: {
            type: 'string',
        },
        m_pxper: {
            type: "string",
            default: 'px',
        },
        p_pex: {
            type: "string",
            default: 'px',
        },
        gradient_bg: {
            type: 'string'
        },
    },

    edit: (props) => {
        const p_px = () => {
            var x = document.getElementById("p_px");
            var y = document.getElementById("p_per");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({ m_pxper: "px" })
        }
        const select_divider = (val) => {
            var top_divider = document.getElementsByClassName('top_divider')[0];
            var bottom_divider = document.getElementsByClassName('bottom_divider')[0];
            if (val === "top") {
                top_divider.style.display = "block"
                bottom_divider.style.display = "none"
            } else {
                top_divider.style.display = "none"
                bottom_divider.style.display = "block"
            }
        }
        const hexConverter = (val) => {
            val = Math.round(val * 100) / 100;
            var alpha = Math.round(val * 255);
            var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
            props.setAttributes({ opacity_value: hex })
        }
        const p_per = () => {
            var x = document.getElementById("p_px");
            var y = document.getElementById("p_per");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({ m_pxper: "%" })
        }
        const m_px = () => {
            var x = document.getElementById("m_px");
            var y = document.getElementById("m_per");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({ p_pex: "px" })
        }
        const m_per = () => {
            var x = document.getElementById("m_px");
            var y = document.getElementById("m_per");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({ p_pex: "%" })
        }
        const shadow_box = () => {
            var x = document.getElementById("shadow");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        };
        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        };
        const remove_img = () => {
            props.setAttributes({
                img_ID: null,
                img_alt: null,
                img_URL: 'undefined',
            })
        };
        const Divtag = props.attributes.heading_tag;
        const boxShadowReset = () => {
            props.setAttributes({
                hori_shadow: '0',
                vertical_shadow: '0',
                blur_shadow: '0',
                spread_shadow: '0',
                shadow_color: '',
                shadow_selector: ''
            })
        }

     
        return (
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__('Layout', 'blocks-bakery')} initialOpen={false}>
                        <RangeControl
                            label={__('Content Width', 'blocks-bakery')}
                            min={0}
                            max={1000}
                            initialPosition={610}
                            value={props.attributes.width_content}
                            onChange={(new_val) => {
                                props.setAttributes({ width_content: new_val })
                            }} />
                        <SelectControl
                            label={__('HTML Tag', 'blocks-bakery')}
                            value={props.attributes.heading_tag}
                            options={[
                                { value: 'div', label: 'Div' },
                                { value: 'header', label: 'Header' },
                                { value: 'footer', label: 'Footer' },
                                { value: 'main', label: 'Main' },
                                { value: 'article', label: 'Article' },
                                { value: 'section', label: 'Section' },
                                { value: 'aside', label: 'Aside' },
                                { value: 'nav', label: 'Nav' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_tag: new_val })
                            }}
                        />
                    </PanelBody>
                    <PanelBody title={__('Spacing', 'blocks-bakery')} initialOpen={false}>
                        <PanelRow>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: 82 }}>Padding</p>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span> <Dashicon icon="desktop" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="tablet" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="phone" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button onClick={p_px} id="p_px" style={{ fontSize: 12, marginTop: "9px", paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                <Button onClick={p_per} id="p_per" style={{ fontSize: 10, marginTop: "10px", padding: 0 }}><span style={{ height: 30 }}>%</span></Button>
                            </div>
                        </PanelRow>
                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    initialPosition={20}
                                    value={props.attributes.top_padding}
                                    onChange={(new_val) => {
                                        props.setAttributes({ top_padding: new_val })
                                    }} />

                            </div>

                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ top_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>
                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.bottom_padding}

                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bottom_padding: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ bottom_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.left_padding}

                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ left_padding: new_val })
                                    }} />

                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ left_padding: 20 })
                                }}> Reset
                            </Button>

                        </div>


                        {/* 4th */}

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.right_padding}

                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ right_padding: new_val })
                                    }} />


                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ right_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>
                        <hr />

                        {/* Padding Start */}


                        <PanelRow>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: 82 }}>Margin</p>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span> <Dashicon icon="desktop" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="tablet" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="phone" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button onClick={m_px} id="m_px" style={{ fontSize: 12, marginTop: "9px", paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                <Button onClick={m_per} id="m_per" style={{ fontSize: 10, marginTop: "10px", padding: 0 }}><span style={{ height: 30 }}>%</span></Button>
                            </div>

                        </PanelRow>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    initialPosition={70}
                                    value={props.attributes.top_margin}

                                    onChange={(new_val) => {
                                        props.setAttributes({ top_margin: new_val })
                                    }} />

                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ top_margin: 70 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.bottom_margin}

                                    initialPosition={70}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bottom_margin: new_val })
                                    }} />

                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ bottom_margin: 70 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.left_margin}

                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ left_margin: new_val })
                                    }} />
                            </div>

                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ left_margin: 70 })
                                }}> Reset
                            </Button>

                        </div>
                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>

                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.right_margin}

                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ right_margin: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ right_margin: 70 })
                                }}> Reset
                            </Button>
                        </div>
                    </PanelBody>
                    <PanelBody title={__('Background', 'block-for-editors')} initialOpen={false}>
                        <PanelBody title={__("Background Color", 'blocks-bakery')} initialOpen={false}>
                            <p><span>{__('Background Color1', 'blocks-bakery')}
                                <ColorIndicator style={{ backgroundColor: props.attributes.bg_color }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                value={props.attributes.bg_color}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_color: new_val })
                                    props.setAttributes({gradient_bg:props.attributes.bg_color})
                                }}

                            />

                                           
                            <RangeControl
                                label={__('Opacity', 'blocks-bakery')}
                                min={0}
                                max={1}
                                value={props.attributes.opacity_value}
                                step={0.01}
                                onChange={(new_val) => {
                                    props.setAttributes({ opacity_value: new_val })
                                    hexConverter(new_val)
                                }}
                            />

                        </PanelBody>

                        <PanelBody title={__("Gradient Color", 'blocks-bakery')} initialOpen={false}>
                            <__experimentalGradientPicker
                                value={props.attributes.gradient_bg}
                                onChange={(new_val) => {
                                    props.setAttributes({ gradient_bg: new_val })
                                    props.setAttributes({bg_color:'transparent'})  
                                    // props.setAttributes({
                                    //     img_ID: null,
                                    //     img_URL: null,
                                    //     img_alt: null
                                    // })
                                }}
                            />
                        </PanelBody>
                        <PanelBody title={__("Image or video", 'blocks-bakery')} initialOpen={false}>
                            {props.attributes.img_ID ? (
                                <div className="image-ctr">
                                    <img src={props.attributes.img_URL}
                                        alt={props.attributes.img_alt} />

                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img}>
                                            <Dashicon icon='no' size='20' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID}
                                        onSelect={select_img}

                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {__('Upload Image/Video', 'blocks-bakery')}
                                            </Button>
                                        )}></MediaUpload>
                                </MediaUploadCheck>
                            )}
                            <SelectControl
                                label="Image Position"
                                options={[
                                    { label: 'Top Left', value: 'top left' },
                                    { label: 'Top Center', value: 'top center' },
                                    { label: 'Top Right', value: 'top right' },
                                    { label: 'Center Left', value: 'center left' },
                                    { label: 'Center Center', value: 'center' },
                                    { label: 'Center Right', value: 'center right' },
                                    { label: 'Bottom Left', value: 'bottom left' },
                                    { label: 'Bottom Center', value: 'bottom center' },
                                    { label: 'Bottom Right', value: 'bottom right' },
                                ]}
                                value={props.attributes.imgbgposition}
                                onChange={(new_val) => {
                                    props.setAttributes({ imgbgposition: new_val })
                                }}
                            />
                            <SelectControl
                                label="Attachment"
                                options={[
                                    { label: 'Fixed', value: 'fixed' },
                                    { label: 'Scroll', value: 'scroll' },
                                ]}
                                value={props.attributes.bgimgattachment}
                                onChange={(new_val) => {
                                    props.setAttributes({ bgimgattachment: new_val })
                                }}
                            />
                            <SelectControl
                                label="Repeat"
                                options={[
                                    { label: 'No Repeat', value: 'no-repeat' },
                                    { label: 'Repeat', value: 'repeat' },
                                    { label: 'Repeat-X', value: 'repeat-x' },
                                    { label: 'Repeat-Y', value: 'repeat-y' },
                                ]}
                                value={props.attributes.bgimgrepeat}
                                onChange={(new_val) => {
                                    props.setAttributes({ bgimgrepeat: new_val })
                                }}
                            />
                            <SelectControl
                                label="Size"
                                options={[
                                    { label: 'Auto', value: 'auto' },
                                    { label: 'Cover', value: 'cover' },
                                    { label: 'Contain', value: 'contain' },
                                ]}
                                value={props.attributes.bgimgsize}
                                onChange={(new_val) => {
                                    props.setAttributes({ bgimgsize: new_val })
                                }}
                            />
                            {/* <RangeControl
                                label={__('Opacity12', 'blocks-bakery')}
                                min={0}
                                max={1}
                                value={props.attributes.bg_color_opacity}
                                step={0.1}
                                initialPosition={1}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_color_opacity: new_val })
                                }}
                            /> */}
                            {/* <Button style={{
                                background: 'lightblue', borderRadius: '5px', width: '100px', display: 'flow-root', fontSize: '18px   '
                            }}
                                onClick={() => {
                                    props.setAttributes({
                                        bg_selctor_type_img: `url(${props.attributes.img_URL})`,
                                    })
                                }}> Save </Button> */}
                        </PanelBody>
                    </PanelBody>
                    <PanelBody title={__('Shape dividers', 'block-for-editors')} initialOpen={false}>
                        <SelectControl
                            label="Shape Divider Position"
                            options={[
                                { label: 'To Top', value: 'top' },
                                { label: 'To Bottom', value: 'bottom' },
                            ]}
                            value={props.attributes.shape_divider_position}
                            onChange={(new_val) => {
                                props.setAttributes({ shape_divider_position: new_val })
                                select_divider(new_val)
                            }}
                        />
                        <div className="top_divider" style={{ padding: '10px', borderRadius: "5px", border: "1px solid gray" }}>
                            <h2 style={{ textAlign: 'center', margin: '0px' }}>Top Shape Divider</h2>
                            <SelectControl
                                label={__('Type', 'blocks-bakery')}
                                options={[
                                    { label: 'none', value: 'none' },
                                    { label: 'Polygon', value: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxLjQxNCI+PHBhdGggZD0iTTEyIDEybDEyIDEySDBsMTItMTJ6IiBmaWxsPSIjZmZmIi8+PC9zdmc+' },
                                    { label: 'Waves Opacity 1', value: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSI2NXB4IiB2aWV3Qm94PSIwIDAgMTI4MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTEyODAgMy40QzEwNTAuNTkgMTggMTAxOS40IDg0Ljg5IDczNC40MiA4NC44OWMtMzIwIDAtMzIwLTg0LjMtNjQwLTg0LjNDNTkuNC41OSAyOC4yIDEuNiAwIDMuNFYxNDBoMTI4MHoiIGZpbGwtb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNMCAyNC4zMWM0My40Ni01LjY5IDk0LjU2LTkuMjUgMTU4LjQyLTkuMjUgMzIwIDAgMzIwIDg5LjI0IDY0MCA4OS4yNCAyNTYuMTMgMCAzMDcuMjgtNTcuMTYgNDgxLjU4LTgwVjE0MEgweiIgZmlsbC1vcGFjaXR5PSIuNSIvPjxwYXRoIGQ9Ik0xMjgwIDUxLjc2Yy0yMDEgMTIuNDktMjQyLjQzIDUzLjQtNTEzLjU4IDUzLjQtMzIwIDAtMzIwLTU3LTY0MC01Ny00OC44NS4wMS05MC4yMSAxLjM1LTEyNi40MiAzLjZWMTQwaDEyODB6Ii8+PC9nPjwvc3ZnPg==" },
                                    { label: 'Waves', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNOTg1LjY2LDkyLjgzQzkwNi42Nyw3Miw4MjMuNzgsMzEsNzQzLjg0LDE0LjE5Yy04Mi4yNi0xNy4zNC0xNjguMDYtMTYuMzMtMjUwLjQ1LjM5LTU3Ljg0LDExLjczLTExNCwzMS4wNy0xNzIsNDEuODZBNjAwLjIxLDYwMC4yMSwwLDAsMSwwLDI3LjM1VjEyMEgxMjAwVjk1LjhDMTEzMi4xOSwxMTguOTIsMTA1NS43MSwxMTEuMzEsOTg1LjY2LDkyLjgzWiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Curve', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjAwLDExMi43N0MyNjguNjMsMTEyLjc3LDAsNjUuNTIsMCw3LjIzVjEyMEgxMjAwVjcuMjNDMTIwMCw2NS41Miw5MzEuMzcsMTEyLjc3LDYwMCwxMTIuNzdaIiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Waves opacity 2', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNMCwwVjQ2LjI5YzQ3Ljc5LDIyLjIsMTAzLjU5LDMyLjE3LDE1OCwyOCw3MC4zNi01LjM3LDEzNi4zMy0zMy4zMSwyMDYuOC0zNy41QzQzOC42NCwzMi40Myw1MTIuMzQsNTMuNjcsNTgzLDcyLjA1YzY5LjI3LDE4LDEzOC4zLDI0Ljg4LDIwOS40LDEzLjA4LDM2LjE1LTYsNjkuODUtMTcuODQsMTA0LjQ1LTI5LjM0Qzk4OS40OSwyNSwxMTEzLTE0LjI5LDEyMDAsNTIuNDdWMFoiIG9wYWNpdHk9Ii4yNSIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjxwYXRoICBkPSJNMCwwVjE1LjgxQzEzLDM2LjkyLDI3LjY0LDU2Ljg2LDQ3LjY5LDcyLjA1LDk5LjQxLDExMS4yNywxNjUsMTExLDIyNC41OCw5MS41OGMzMS4xNS0xMC4xNSw2MC4wOS0yNi4wNyw4OS42Ny0zOS44LDQwLjkyLTE5LDg0LjczLTQ2LDEzMC44My00OS42NywzNi4yNi0yLjg1LDcwLjksOS40Miw5OC42LDMxLjU2LDMxLjc3LDI1LjM5LDYyLjMyLDYyLDEwMy42Myw3Myw0MC40NCwxMC43OSw4MS4zNS02LjY5LDExOS4xMy0yNC4yOHM3NS4xNi0zOSwxMTYuOTItNDMuMDVjNTkuNzMtNS44NSwxMTMuMjgsMjIuODgsMTY4LjksMzguODQsMzAuMiw4LjY2LDU5LDYuMTcsODcuMDktNy41LDIyLjQzLTEwLjg5LDQ4LTI2LjkzLDYwLjY1LTQ5LjI0VjBaIiBvcGFjaXR5PSIuNSIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjxwYXRoICBkPSJNMCwwVjUuNjNDMTQ5LjkzLDU5LDMxNC4wOSw3MS4zMiw0NzUuODMsNDIuNTdjNDMtNy42NCw4NC4yMy0yMC4xMiwxMjcuNjEtMjYuNDYsNTktOC42MywxMTIuNDgsMTIuMjQsMTY1LjU2LDM1LjRDODI3LjkzLDc3LjIyLDg4Niw5NS4yNCw5NTEuMiw5MGM4Ni41My03LDE3Mi40Ni00NS43MSwyNDguOC04NC44MVYwWiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Curve asymmetric', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNzQxLDExNi4yM0MyOTEsMTE3LjQzLDAsMjcuNTcsMCw2VjEyMEgxMjAwVjZDMTIwMCwyNy45MywxMTg2LjQsMTE5LjgzLDc0MSwxMTYuMjNaIiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Triangle', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNTk4Ljk3IDExNC43MkwwIDAgMCAxMjAgMTIwMCAxMjAgMTIwMCAwIDU5OC45NyAxMTQuNzJ6IiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Triangle asymmetric', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNODkyLjI1IDExNC43MkwwIDAgMCAxMjAgMTIwMCAxMjAgMTIwMCAwIDg5Mi4yNSAxMTQuNzJ6IiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Tilt', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNMTIwMCAxMjBMMCAxNi40OCAwIDAgMTIwMCAwIDEyMDAgMTIweiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Arrow', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjQ5Ljk3IDBMNTk5LjkxIDU0LjEyIDU1MC4wMyAwIDAgMCAwIDEyMCAxMjAwIDEyMCAxMjAwIDAgNjQ5Ljk3IDB6IiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Split', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjAwLDE2LjhjMC04LjExLTguODgtMTMuMi0xOS45Mi0xMy4ySDBWMTIwSDEyMDBWMy42SDYxOS45MkM2MDguODgsMy42LDYwMCw4LjY2LDYwMCwxNi44WiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Book', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjAyLjQ1LDMuODZoMFM1NzIuOSwxMTYuMjQsMjgxLjk0LDEyMEg5MjNDNjMyLDExNi4yNCw2MDIuNDUsMy44Niw2MDIuNDUsMy44NloiIGNsYXNzPSJzaGFwZS1maWxsIiBmaWxsPSIjRkRGQUZBIiBmaWxsLW9wYWNpdHk9IjEiPjwvcGF0aD48L3N2Zz4=" },
                                ]}
                                value={props.attributes.select_divider_top}
                                onChange={(new_val) => {
                                    props.setAttributes({ select_divider_top: new_val })
                                }}
                            />
                            <ColorIndicator style={{ backgroundColor: props.attributes.divider_color_top }} />
                            <ColorPalette
                                value={props.attributes.divider_color_top}
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_color_top: new_val })
                                }}
                            />
                                   <div className="range-controler" style={{ display: "flex",alignItems:"center",justifyContent:"center" }}>


                             <div style={{ marginRight: "10px", width: "100%" }}>
                            <RangeControl
                                label="Opacity"
                              
                                initialPosition={1}
                                min={0}
                                max={1}
                                step={0.1}
                                value={props.attributes.divider_opacity_top}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_opacity_top: new_val })
                                }}
                            />
                            </div>

                            <Button style={{
                                marginTop:12,
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ divider_opacity_top: 1 })
                                }}> Reset
                            </Button>
                            </div>
                            <RangeControl
                                label="Width"
                                initialPosition={100}
                                min={0}
                                max={100}
                                value={props.attributes.divider_width_top}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_width_top: new_val })
                                }}
                            />
                            <RangeControl
                                label="Height"
                                initialPosition={100}
                                min={0}
                                max={500}
                                value={props.attributes.divider_height_top}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_height_top: new_val })
                                }}
                            />
                        </div>
                        <div className="bottom_divider" style={{ display: "none", padding: '10px', borderRadius: "5px", border: "1px solid gray" }}>
                            <h2 style={{ textAlign: 'center', margin: '0px' }}>Bottom Shape Divider</h2>
                            <SelectControl
                                label={__('Type', 'blocks-bakery')}
                                options={[
                                    { label: 'none', value: 'none' },
                                    { label: 'Polygon', value: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxLjQxNCI+PHBhdGggZD0iTTEyIDEybDEyIDEySDBsMTItMTJ6IiBmaWxsPSIjZmZmIi8+PC9zdmc+' },
                                    { label: 'Waves Opacity 1', value: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSI2NXB4IiB2aWV3Qm94PSIwIDAgMTI4MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTEyODAgMy40QzEwNTAuNTkgMTggMTAxOS40IDg0Ljg5IDczNC40MiA4NC44OWMtMzIwIDAtMzIwLTg0LjMtNjQwLTg0LjNDNTkuNC41OSAyOC4yIDEuNiAwIDMuNFYxNDBoMTI4MHoiIGZpbGwtb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNMCAyNC4zMWM0My40Ni01LjY5IDk0LjU2LTkuMjUgMTU4LjQyLTkuMjUgMzIwIDAgMzIwIDg5LjI0IDY0MCA4OS4yNCAyNTYuMTMgMCAzMDcuMjgtNTcuMTYgNDgxLjU4LTgwVjE0MEgweiIgZmlsbC1vcGFjaXR5PSIuNSIvPjxwYXRoIGQ9Ik0xMjgwIDUxLjc2Yy0yMDEgMTIuNDktMjQyLjQzIDUzLjQtNTEzLjU4IDUzLjQtMzIwIDAtMzIwLTU3LTY0MC01Ny00OC44NS4wMS05MC4yMSAxLjM1LTEyNi40MiAzLjZWMTQwaDEyODB6Ii8+PC9nPjwvc3ZnPg==" },
                                    { label: 'Waves', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNMzIxLjM5LDU2LjQ0YzU4LTEwLjc5LDExNC4xNi0zMC4xMywxNzItNDEuODYsODIuMzktMTYuNzIsMTY4LjE5LTE3LjczLDI1MC40NS0uMzlDODIzLjc4LDMxLDkwNi42Nyw3Miw5ODUuNjYsOTIuODNjNzAuMDUsMTguNDgsMTQ2LjUzLDI2LjA5LDIxNC4zNCwzVjBIMFYyNy4zNUE2MDAuMjEsNjAwLjIxLDAsMCwwLDMyMS4zOSw1Ni40NFoiIGNsYXNzPSJzaGFwZS1maWxsIiBmaWxsPSIjRkRGQUZBIiBmaWxsLW9wYWNpdHk9IjEiPjwvcGF0aD48L3N2Zz4=" },
                                    { label: 'Curve', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjAwLDExMi43N0MyNjguNjMsMTEyLjc3LDAsNjUuNTIsMCw3LjIzVjEyMEgxMjAwVjcuMjNDMTIwMCw2NS41Miw5MzEuMzcsMTEyLjc3LDYwMCwxMTIuNzdaIiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Waves opacity 2', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNMCwwVjQ2LjI5YzQ3Ljc5LDIyLjIsMTAzLjU5LDMyLjE3LDE1OCwyOCw3MC4zNi01LjM3LDEzNi4zMy0zMy4zMSwyMDYuOC0zNy41QzQzOC42NCwzMi40Myw1MTIuMzQsNTMuNjcsNTgzLDcyLjA1YzY5LjI3LDE4LDEzOC4zLDI0Ljg4LDIwOS40LDEzLjA4LDM2LjE1LTYsNjkuODUtMTcuODQsMTA0LjQ1LTI5LjM0Qzk4OS40OSwyNSwxMTEzLTE0LjI5LDEyMDAsNTIuNDdWMFoiIG9wYWNpdHk9Ii4yNSIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjxwYXRoICBkPSJNMCwwVjE1LjgxQzEzLDM2LjkyLDI3LjY0LDU2Ljg2LDQ3LjY5LDcyLjA1LDk5LjQxLDExMS4yNywxNjUsMTExLDIyNC41OCw5MS41OGMzMS4xNS0xMC4xNSw2MC4wOS0yNi4wNyw4OS42Ny0zOS44LDQwLjkyLTE5LDg0LjczLTQ2LDEzMC44My00OS42NywzNi4yNi0yLjg1LDcwLjksOS40Miw5OC42LDMxLjU2LDMxLjc3LDI1LjM5LDYyLjMyLDYyLDEwMy42Myw3Myw0MC40NCwxMC43OSw4MS4zNS02LjY5LDExOS4xMy0yNC4yOHM3NS4xNi0zOSwxMTYuOTItNDMuMDVjNTkuNzMtNS44NSwxMTMuMjgsMjIuODgsMTY4LjksMzguODQsMzAuMiw4LjY2LDU5LDYuMTcsODcuMDktNy41LDIyLjQzLTEwLjg5LDQ4LTI2LjkzLDYwLjY1LTQ5LjI0VjBaIiBvcGFjaXR5PSIuNSIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjxwYXRoICBkPSJNMCwwVjUuNjNDMTQ5LjkzLDU5LDMxNC4wOSw3MS4zMiw0NzUuODMsNDIuNTdjNDMtNy42NCw4NC4yMy0yMC4xMiwxMjcuNjEtMjYuNDYsNTktOC42MywxMTIuNDgsMTIuMjQsMTY1LjU2LDM1LjRDODI3LjkzLDc3LjIyLDg4Niw5NS4yNCw5NTEuMiw5MGM4Ni41My03LDE3Mi40Ni00NS43MSwyNDguOC04NC44MVYwWiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Curve asymmetric', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNzQxLDExNi4yM0MyOTEsMTE3LjQzLDAsMjcuNTcsMCw2VjEyMEgxMjAwVjZDMTIwMCwyNy45MywxMTg2LjQsMTE5LjgzLDc0MSwxMTYuMjNaIiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Triangle', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNTk4Ljk3IDExNC43MkwwIDAgMCAxMjAgMTIwMCAxMjAgMTIwMCAwIDU5OC45NyAxMTQuNzJ6IiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Triangle asymmetric', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNODkyLjI1IDExNC43MkwwIDAgMCAxMjAgMTIwMCAxMjAgMTIwMCAwIDg5Mi4yNSAxMTQuNzJ6IiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Tilt', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNMTIwMCAxMjBMMCAxNi40OCAwIDAgMTIwMCAwIDEyMDAgMTIweiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Arrow', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjQ5Ljk3IDBMNTk5LjkxIDU0LjEyIDU1MC4wMyAwIDAgMCAwIDEyMCAxMjAwIDEyMCAxMjAwIDAgNjQ5Ljk3IDB6IiBjbGFzcz0ic2hhcGUtZmlsbCIgZmlsbD0iI0ZERkFGQSIgZmlsbC1vcGFjaXR5PSIxIj48L3BhdGg+PC9zdmc+" },
                                    { label: 'Split', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjAwLDE2LjhjMC04LjExLTguODgtMTMuMi0xOS45Mi0xMy4ySDBWMTIwSDEyMDBWMy42SDYxOS45MkM2MDguODgsMy42LDYwMCw4LjY2LDYwMCwxNi44WiIgY2xhc3M9InNoYXBlLWZpbGwiIGZpbGw9IiNGREZBRkEiIGZpbGwtb3BhY2l0eT0iMSI+PC9wYXRoPjwvc3ZnPg==" },
                                    { label: 'Book', value: "data:image/svg+xml;base64,PHN2ZyAgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEyMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgPjxwYXRoICBkPSJNNjAyLjQ1LDMuODZoMFM1NzIuOSwxMTYuMjQsMjgxLjk0LDEyMEg5MjNDNjMyLDExNi4yNCw2MDIuNDUsMy44Niw2MDIuNDUsMy44NloiIGNsYXNzPSJzaGFwZS1maWxsIiBmaWxsPSIjRkRGQUZBIiBmaWxsLW9wYWNpdHk9IjEiPjwvcGF0aD48L3N2Zz4=" },
                                ]}
                                value={props.attributes.select_divider_bottom}
                                onChange={(new_val) => {
                                    props.setAttributes({ select_divider_bottom: new_val })
                                }}
                            />
                            <ColorIndicator style={{ backgroundColor: props.attributes.divider_color_bottom }} />
                            <ColorPalette
                                value={props.attributes.divider_color_bottom}
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_color_bottom: new_val })
                                }}
                            />
                            <RangeControl
                                label="Opacity"
                                allowReset={true}
                                initialPosition={1}
                                min={0}
                                max={1}
                                step={0.1}
                                value={props.attributes.divider_opacity_bottom}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_opacity_bottom: new_val })
                                }}
                            />
                            <RangeControl
                                label="Width"
                                initialPosition={100}
                                min={0}
                                max={100}
                                value={props.attributes.divider_width_bottom}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_width_bottom: new_val })
                                }}
                            />
                            <RangeControl
                                label="Height"
                                initialPosition={100}
                                min={0}
                                max={500}
                                value={props.attributes.divider_height_bottom}
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_height_bottom: new_val })
                                }}
                            />
                        </div>

                    </PanelBody>
                    <PanelBody title={__('Border', 'block-for-editors')} initialOpen={false}>
                        <SelectControl
                            label={__('Border Style', 'blocks-bakery')}
                            value={props.attributes.select_border}
                            options={[
                                { value: 'none', label: 'None' },
                                { value: 'solid', label: 'Solid' },
                                { value: 'dotted', label: 'Dotted' },
                                { value: 'dashed', label: 'Dashed' },
                                { value: 'double', label: 'Double' },
                                { value: 'groove', label: 'Groove' },
                                { value: 'inset', label: 'Inset' },
                                { value: 'outset', label: 'Outset' },
                                { value: 'ridge', label: 'Ridge' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ select_border: new_val })
                            }}
                        />
                        <div className="range-controler" style={{ display: "flex",justifyContent:"center",alignItems:"center" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    label={__('Border Width', 'blocks-bakery')}
                                    min={0}
                                    max={50}
                                    value={props.attributes.border_width}
                                    initialPosition={1}
                                    onChange={(new_val) => {
                                        props.setAttributes({ border_width: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                marginTop:13,
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ border_width: 1 })
                                }}> Reset
                            </Button>
                        </div>

                          <div className="range-controler" style={{ display: "flex",justifyContent:"center",alignItems:"center" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                        <RangeControl
                            label={__('Border Radius', 'blocks-bakery')}
                            min={0}
                            max={200}
                            value={props.attributes.border_radius}
                 
                            initialPosition={0}
                            onChange={(new_val) => {
                                props.setAttributes({ border_radius: new_val })
                            }} />
  </div>
                            <Button style={{
                                marginTop:13,
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ border_radius: 1 })
                                }}> Reset
                            </Button>
                        </div>
                        <p>Border Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.border_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.border_color}
                            onChange={(new_val) => {
                                props.setAttributes({ border_color: new_val })
                            }}
                        />
                        <PanelRow>
                            <p>Box Shadow</p>
                            <div>
                                <Button onClick={boxShadowReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={shadow_box} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id='shadow' style={{ display: 'none' }}>
                            <CardBody>
                                <p>Color<span>
                                    <ColorIndicator
                                        style={{ backgroundColor: props.attributes.shadow_color }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    value={props.attributes.shadow_color}
                                    onChange={(new_val) => {
                                        props.setAttributes({ shadow_color: new_val })
                                    }}
                                />
                                  <Button style={{
                                            background: '#007cba', position:"relative",top:"-28px",left:"151px", border: '1px solid #007cba', fontSize: '12px', width: "27%", height: "30px", color: "#ffffff"
                                        }}
                                            onClick={() => {
                                           var x= document.querySelector(".gb-ad-col-tagChange");
                                            x.style.backgroundColor = "transparent"
                                            props.setAttributes({shadow_color:'transparent'})
                                            }}> Reset
                                        </Button>

                                <RangeControl
                                    label={__('Horizontal', 'blocks-bakery')}
                                    min={-100}
                                    max={100}
                                    value={props.attributes.hori_shadow}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ hori_shadow: new_val })
                                    }} />
                                <RangeControl
                                    label={__('Vertical', 'blocks-bakery')}
                                    min={-100}
                                    max={100}
                                    value={props.attributes.vertical_shadow}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ vertical_shadow: new_val })

                                    }} />
                                <RangeControl
                                    label={__('Blur', 'blocks-bakery')}
                                    min={0}
                                    max={100}
                                    value={props.attributes.blur_shadow}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ blur_shadow: new_val })
                                    }} />
                                <RangeControl
                                    label={__('Spread', 'blocks-bakery')}
                                    min={0}
                                    max={100}
                                    value={props.attributes.spread_shadow}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ spread_shadow: new_val })
                                    }} />
                                <SelectControl
                                    label={__('Position', 'blocks-bakery')}
                                    value={props.attributes.shadow_selector}
                                    options={[
                                        { value: 'inset', label: 'inset' },
                                        { value: '', label: 'outset' },
                                    ]}
                                    onChange={(new_val) => {
                                        props.setAttributes({ shadow_selector: new_val })
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </PanelBody>
                </InspectorControls>
                <BlockControls>
                    <BlockAlignmentToolbar
                        value={props.attributes.block_alignment}
                        onChange={(new_val) => {
                            props.setAttributes({ block_alignment: new_val })
                        }} />
                    <AlignmentToolbar
                        value={props.attributes.text_alignment}
                        onChange={(new_val) => {
                            props.setAttributes({ text_alignment: new_val });
                        }} />
                </BlockControls>
                <div className={`align${props.attributes.block_alignment}  gb-ad-col-main`}>
                    <Divtag id='main_div' className="gb-ad-col-tagChange  " style={{
                        borderStyle: props.attributes.select_border,
                        borderWidth: props.attributes.border_width,
                        borderRadius: props.attributes.border_radius,
                        borderColor: props.attributes.border_color,
                        boxShadow: props.attributes.hori_shadow + 'px' + ' ' + props.attributes.vertical_shadow + 'px' + ' ' + props.attributes.blur_shadow + 'px' + ' ' + props.attributes.spread_shadow + 'px' + ' ' + props.attributes.shadow_color + ' ' + props.attributes.shadow_selector,
                        marginTop: props.attributes.top_margin + props.attributes.p_pex, overflow: 'auto',
                        marginBottom: props.attributes.bottom_margin + props.attributes.p_pex,
                        marginLeft: props.attributes.left_margin + props.attributes.p_pex,
                        marginRight: props.attributes.right_margin + props.attributes.p_pex,
                        width: props.attributes.width_content, minWidth: '150px',
                        backgroundSize: props.attributes.bgimgsize,
                         backgroundPosition: props.attributes.imgbgposition,
                          backgroundRepeat: props.attributes.bgimgrepeat,
                        backgroundAttachment: props.attributes.bgimgattachment,
                        // opacity: props.attributes.bg_color_opacity,
                        backgroundImage: 'url(' + props.attributes.img_URL + ')',


                    }}>
                        <div className="top-divider" style={{
                            borderRadius: props.attributes.border_radius,
                            position: 'relative',
                            backgroundColor: props.attributes.divider_color_top,
                     
                            backgroundImage: `url(${props.attributes.select_divider_top})`,
                            width: props.attributes.divider_width_top + '%',
                            height: props.attributes.divider_height_top + 'px',
                            opacity: props.attributes.divider_opacity_top,
                            top: '0',
                            left: '0',
                        
                    
                        }}>
                        </div>
                        <div className="overlay" style={{

                          paddingTop: props.attributes.top_padding + props.attributes.m_pxper,
                             paddingBottom: props.attributes.bottom_padding + props.attributes.m_pxper,
                             paddingLeft: props.attributes.left_padding + props.attributes.m_pxper,
                             paddingRight: props.attributes.right_padding + props.attributes.m_pxper,
                             background: props.attributes.gradient_bg,
                             backgroundColor: props.attributes.bg_color + props.attributes.opacity_value, 
                
                        }}>

                            <div className="gb-ad-col-divider-innerBlock"  >
                                <InnerBlocks
                                    allowedBlocks={['blocksbakery/advanced-column']}
                                    template={[
                                        ['blocksbakery/advanced-column'],
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="bottom-divider" style={{
                            position: 'relative',
                            backgroundColor: props.attributes.divider_color_bottom,
                       
                            backgroundImage: `url(${props.attributes.select_divider_bottom})`,
                            width: props.attributes.divider_width_bottom + "%",
                            height: props.attributes.divider_height_bottom + 'px',
                            opacity: props.attributes.divider_opacity_bottom,
                            bottom: '0',
                            left: '0'
                        }}>
                        </div>
                    </Divtag>
                </div>
            </React.Fragment>
        )
    },

    save: (props) => {
        const Divtag = props.attributes.heading_tag;
        return (
            <div className={`align${props.attributes.block_alignment}  gb-ad-col-main`}>
                <div className="gb-ad-col-main-inner" style={{ textAlign: props.attributes.text_alignment }}>
                    <Divtag className='gb-ad-col-tagChange' style={{
                        borderStyle: props.attributes.select_border,
                         borderWidth: props.attributes.border_width,
                          borderRadius: props.attributes.border_radius,
                        borderColor: props.attributes.border_color,
                        boxShadow: props.attributes.hori_shadow + 'px' + ' ' + props.attributes.vertical_shadow + 'px' + ' ' + props.attributes.blur_shadow + 'px' + ' ' + props.attributes.spread_shadow + 'px' + ' ' + props.attributes.shadow_color + ' ' + props.attributes.shadow_selector,
                        marginTop: props.attributes.top_margin + props.attributes.p_pex, overflow: "auto",
                        marginBottom: props.attributes.bottom_margin + props.attributes.p_pex,
                        marginLeft: props.attributes.left_margin + props.attributes.p_pex,
                        marginRight: props.attributes.right_margin + props.attributes.p_pex,
                        width: props.attributes.width_content, minWidth: '150px',
                        backgroundImage: `url(${props.attributes.img_URL})`,
                        backgroundSize: props.attributes.bgimgsize, backgroundPosition: props.attributes.imgbgposition, backgroundRepeat: props.attributes.bgimgrepeat,
                        backgroundAttachment: props.attributes.bgimgattachment,

                        // opacity: props.attributes.bg_color_opacity,

                    }}>
                        <div style={{
                            position: 'relative',
                            backgroundColor: props.attributes.divider_color_top,
                            content: '',
                            backgroundImage: `url(${props.attributes.select_divider_top})`,
                            width: props.attributes.divider_width_top + '%',
                            height: props.attributes.divider_height_top + 'px',
                            opacity: props.attributes.divider_opacity_top,
                            top: '0',
                            left: '0',
                            // zindex:props.attributes.select_type_bk_ft,
                        }}>
                        </div>

                        <div className="overlay" style={{
                             paddingTop: props.attributes.top_padding + props.attributes.m_pxper,
                             paddingBottom: props.attributes.bottom_padding + props.attributes.m_pxper,
                             paddingLeft: props.attributes.left_padding + props.attributes.m_pxper,
                             paddingRight: props.attributes.right_padding + props.attributes.m_pxper,
                             background: props.attributes.gradient_bg,
                             backgroundColor: props.attributes.bg_color + props.attributes.opacity_value, 
                
                        }} >

                            <div className="gb-ad-col-divider-innerBlock"  >
                                <InnerBlocks.Content
                                />
                            </div>
                        </div>
                        <div style={{
                            position: 'relative',
                            backgroundColor: props.attributes.divider_color_bottom,
                            content: '',
                            backgroundImage: `url(${props.attributes.select_divider_bottom})`,
                            width: props.attributes.divider_width_bottom + "%",
                            height: props.attributes.divider_height_bottom + 'px',
                            opacity: props.attributes.divider_opacity_bottom,
                            bottom: '0',
                            left: '0'
                        }}>
                        </div>

                    </Divtag>
                </div>
            </div>
        )
    }
})


